import { ApolloClient, ApolloLink, from, HttpLink, InMemoryCache, split } from '@apollo/client/core'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { getMainDefinition } from '@apollo/client/utilities'
import { RestLink } from 'apollo-link-rest'
import { createClient } from 'graphql-ws'

import { createErrorHandler } from '@/plugins/apollo/errorHandler'
import { useUserStore } from '@/stores/user'
import { getSessionId } from '@/utils/session'

// HTTP connection to the API
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: import.meta.env.VITE_APP_PUBLIC_API_HTTP_URL + import.meta.env.VITE_APP_PUBLIC_API_GRAPHQL,
})

// Create the graphql-ws client with reconnection support
const wsClient = createClient({
  url: import.meta.env.VITE_APP_PUBLIC_API_WS_URL,
  lazy: true,
  retryAttempts: 1000,
  shouldRetry: () => true,
  connectionParams: () => {
    const token = useUserStore().token

    return {
      Authorization: token ? `Bearer ${token}` : '',
    }
  },
})

// Create the subscription websocket link
const wsLink = new GraphQLWsLink(wsClient)

// const authLink = setContext((_, { headers }) => {
//   // get the authentication token from local storage if it exists
//   const token = useUserStore().token
//   // return the headers to the context so httpLink can read them
//   return {
//     headers: {
//       ...headers,
//       Authorization: token ? `Bearer ${token}` : null,
//     },
//   }
// })

const authLink = new ApolloLink((operation, forward) => {
  const token = useUserStore().token
  operation.setContext(({ headers }) => ({
    headers: {
      authorization: token ? `Bearer ${token}` : null,
      'X-Correlation-ID': crypto.randomUUID(),
      'X-Session-ID': getSessionId(),
      ...headers,
    },
  }))
  return forward(operation)
})

const errorLink = createErrorHandler(wsClient)

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  wsLink,
  httpLink,
)

// Set `RestLink` with your endpoint
const restLink = new RestLink({ uri: import.meta.env.VITE_APP_PUBLIC_API_HTTP_URL + '/rest' })

// Create the apollo client
// const apolloClient = new ApolloClient({
//   link: from([authLink, with403Error.concat(restLink), link]), // authLink.concat(with403Error).concat(httpLink), // authLink.concat(link) with split link by socket connection
//   cache,
//   connectToDevTools: true,
// })

const apolloClient = new ApolloClient({
  link: from([authLink, errorLink, restLink, link]),
  cache: new InMemoryCache({
    addTypename: true,
  }),
  connectToDevTools: true,
})

export default apolloClient
